import { unsafeCSS } from 'lit'

import { DdsElement } from '@/internal/dds-hu-element'
import { FeedbackMixin } from '@/internal/mixin/feedbackMixin'
import { SizedMixin } from '@/internal/mixin/sizedMixin'

import styles from './_styles/feedback.scss?inline'

/**
 * `dap-ds-feedback`
 * @summary A feedback is a container for feedback messages.
 * @element dap-ds-feedback
 * @title - Feedback
 *
 * @property {string} feedback - The feedback message.
 * @property {'xs' | 'sm' | 'lg'} feedbackSize - The size of the feedback. Default is `sm`.
 * @property {'negative' | 'positive' | 'warning'} feedbackType - The type of the feedback.
 * @property {boolean} feedbackSubtle - The weight of the feedback.
 * @property {boolean} feedbackNoMargin - Removes the margins around the feedback.
 * @property {string} feedbackId - The id of the feedback.
 *
 * @slot icon - The custom icon of the feedback.
 * @slot - The text of the feedback.
 *
 * @csspart base - The main feedback container.
 * @csspart icon - The icon of the feedback.
 * @csspart text - The text of the feedback.
 *
 * @cssproperty --dds-feedback-spacing - The spacing around the feedback component. (default: var(--dds-spacing-200))
 * @cssproperty --dds-feedback-color - The text color of the feedback. (default: var(--dds-text-positive-subtle))
 * @cssproperty --dds-feedback-font-size - The font size of the feedback. (default: var(--dds-font-sm))
 * @cssproperty --dds-feedback-font-weight - The font weight of the feedback. (default: var(--dds-font-weight-bold))
 * @cssproperty --dds-feedback-icon-fill - The fill color of the feedback icon. (default: var(--dds-icon-positive-subtle))
 * @cssproperty --dds-feedback-icon-spacing - The spacing between the icon and text. (default: var(--dds-spacing-100))
 * @cssproperty --dds-feedback-color-warning - The text color for warning feedback. (default: var(--dds-text-neutral-base))
 * @cssproperty --dds-feedback-color-positive - The text color for positive feedback. (default: var(--dds-text-positive-subtle))
 * @cssproperty --dds-feedback-color-negative - The text color for negative feedback. (default: var(--dds-text-negative-subtle))
 * @cssproperty --dds-feedback-icon-fill-warning - The icon fill color for warning feedback. (default: var(--dds-icon-informative-subtle))
 * @cssproperty --dds-feedback-icon-fill-positive - The icon fill color for positive feedback. (default: var(--dds-icon-positive-subtle))
 * @cssproperty --dds-feedback-icon-fill-negative - The icon fill color for negative feedback. (default: var(--dds-icon-negative-subtle))
 */
export default class DapDSFeedback extends FeedbackMixin(
  SizedMixin(DdsElement),
) {
  static tagName = 'dap-ds-feedback'

  static readonly styles = unsafeCSS(styles)

  render() {
    return this.renderFeedback()
  }
}
